import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { DataView } from 'primereact/dataview';
import Data from '../../../../components/Display/Data';
import MultiLineData from '../../../../components/Display/MultiLineData';
import Section from '../../../../components/Display/Section';
import Tag from '../../../../components/Display/Tag';
import CircumstanceItem from '../Circumstance/CircumstanceItem';

function ProjectDetail({
  project,
  handleUpdateProject,
  handleCreateCircumstance,
  handleDeleteCircumstance,
  onSelectCircumstance,
  handleDelete
}) {
  const updateProjectActions = [
    {
      onClick: handleUpdateProject,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const newCircumstanceActions = [
    {
      onClick: handleCreateCircumstance,
      label: 'Ajouter une circonstance',
      icon: 'pi-plus'
    }
  ];

  const confirmDeletion = (project) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce Projet ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(project)
    });
  };

  const confirmCircumstanceDeletion = (crc) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette circonstance ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteCircumstance(crc)
    });
  };

  const itemTemplate = (crc) => (
    <CircumstanceItem
      circumstance={crc}
      handleClickCircumstance={() => onSelectCircumstance(crc)}
      handleDeleteCircumstance={() => confirmCircumstanceDeletion(crc)}
    />
  );

  return (
    <div className="h-full w-full flex-col flex gap-5">
      <Section label="Informations Générales" actions={updateProjectActions}>
        {project.is_highlight && (
          <Tag
            tag={{
              label: 'Projet mis en avant',
              icon: 'star',
              bgColor: 'bg-purple-800'
            }}
            rounded
          />
        )}

        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={project.title} large />
          <Data key="place_name" label={'Localisation'} value={project.place_name} large />
          <Data key="sponsor" label={'Commanditaire'} value={project.sponsor} large />
          <Data key="year" label={'Année'} value={project.year} />
        </div>
        {project.is_highlight && (
          <>
            <div className="flex flex-row gap-5">
              <Data key="surface" label={'Surface'} value={project.surface} suffix={'m²'} />
              <Data key="cost" label={'Budget'} value={project.cost} suffix={'€'} />
              <Data key="team" label={'Equipe'} value={project.team} large />
              <Data
                key="certifications"
                label={'Certifications'}
                value={project.certifications}
                large
              />
            </div>
            <div className="flex flex-row gap-5">
              <MultiLineData
                key="description"
                label={'Description'}
                value={project.description}
                large
                asHtml
              />
            </div>
          </>
        )}
      </Section>

      <Section label="Image Principale">
        {!project?.main_image ? (
          <span className="italic text-slate-400 font-light">Aucune image à afficher</span>
        ) : (
          <img src={project?.main_image?.file} className="w-80" alt={project.title} />
        )}
      </Section>

      {project.is_highlight && (
        <Section label="Circonstances" actions={newCircumstanceActions}>
          <DataView
            value={project.circumstances}
            itemTemplate={itemTemplate}
            className="pb-20"
            emptyMessage="Aucune circonstance"
          />
        </Section>
      )}

      <Section label="Autres actions">
        <div>
          <Button
            key={'delete'}
            label={'Supprimer le projet'}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(project)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default ProjectDetail;
